import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`py-insetY px-insetX grid lg:grid-cols-2 gap-x-8 gap-y-16 items-center`};
`

export const Main = styled.div`
  ${tw`text-center px-16`};
`
